module.exports = __webpack_public_path__ + "static/img/qrp-rtm-color.4aca76c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrp-rtm-color.svg
// module id = IIvh
// module chunks = 2